(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rosy-v42-event-date"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-rosy-event-date]').forEach((root) => {
  const date = root.querySelector('input[type="text"]');
  const types = root.querySelectorAll('input[type="radio"]');
  const result = root.querySelector('[data-result]');
  const title = root.querySelector('[data-result-title]');
  const copy = root.querySelector('[data-result-copy]');
  const parseDate = (value) => {
    const match = value.trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (!match) return null;
    const parsed = new Date(Number(match[3]), Number(match[1]) - 1, Number(match[2]), 12);
    if (parsed.getFullYear() !== Number(match[3]) || parsed.getMonth() !== Number(match[1]) - 1 || parsed.getDate() !== Number(match[2])) return null;
    return parsed;
  };
  const save = async () => {
    const type = Array.from(types).find((input) => input.checked)?.value || '';
    localStorage.setItem('rosy_v5_event_date', date.value);
    localStorage.setItem('rosy_v5_event_type', type);
    await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({attributes: {'Event Date': date.value, 'Planning For': type}})
    });
  };
  date.value = localStorage.getItem('rosy_v5_event_date') || '';
  const savedType = localStorage.getItem('rosy_v5_event_type') || '';
  types.forEach((input) => { input.checked = input.value === savedType; input.addEventListener('change', save); });
  root.querySelector('[data-review]').addEventListener('click', async () => {
    const eventDate = parseDate(date.value);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    result.hidden = false;
    if (!eventDate) {
      title.textContent = 'Enter a valid event date';
      copy.textContent = 'Use MM/DD/YYYY format.';
      return;
    }
    if (eventDate < today) {
      title.textContent = 'Choose a future event date';
      copy.textContent = 'Past dates cannot be used for timing guidance.';
      return;
    }
    const days = Math.ceil((eventDate.getTime() - today.getTime()) / 86400000);
    if (days >= 60) {
      title.textContent = 'Your date allows more planning time';
      copy.textContent = 'Continue shopping and review the product-specific delivery details.';
    } else if (days >= 30) {
      title.textContent = 'Your event is approaching';
      copy.textContent = 'You can continue shopping, or contact us if you would like help reviewing delivery timing.';
    } else {
      title.textContent = 'Rush-delivery options may be available';
      copy.textContent = 'You can continue shopping, or contact us for help reviewing rush options.';
    }
    await save();
  });
  root.querySelector('[data-clear]').addEventListener('click', async () => {
    date.value = '';
    types.forEach((input) => { input.checked = false; });
    result.hidden = true;
    localStorage.removeItem('rosy_v5_event_date');
    localStorage.removeItem('rosy_v5_event_type');
    await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({attributes: {'Event Date': '', 'Planning For': ''}})
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rosy-v5-collection"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-collection-sort]').forEach((select)=>{select.addEventListener('change',()=>select.form.submit())});
  } catch(e) { console.error(e); }
})();
})();
